<template>
  <page-blocks>
    <white-block class="mt-6">
      <tm-empty-state
        icon="lock"
        :title="$t('notFound.header')"
        :description="$t('notFound.text')"
        class="pb-0"
      >
        <template v-slot:footer>
          <div class="d-flex align-center">
            <tm-button
              color="primary"
              size="xLarge"
              :to="{ name: 'user.base' }"
            >
              {{ $t('notFound.backText') }}
            </tm-button>
          </div>
        </template>
      </tm-empty-state>
    </white-block>
  </page-blocks>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'
import WhiteBlock from '@/components/shared/templates/WhiteBlock.vue'
import TmEmptyState from '@/components/shared/TmEmptyState.vue'
import TmButton from '@/components/shared/TmButton.vue'
import PageBlocks from '@/components/layout/PageBlocks.vue'

export default defineComponent({
  components: {
    WhiteBlock,
    TmEmptyState,
    TmButton,
    PageBlocks,
  },
})
</script>
